import { Document, Page, View } from "@react-pdf/renderer";
import Desription from "./components/description";
import Header from "./components/header";
import Holder from "./components/holder";
import PartOne from "./components/partOne";
import PartTwo from "./components/partTwo/partTwo";

function Certificate({
  producer,
  data,
  customerHolder,
  signature,
  contact,
  agency,
}) {
  function extractCarrierInfo(coverages) {
    if (!coverages) return Array(6).fill(null);

    const result = Array(6).fill(null);

    // Insurer A: General Liability (tgl)
    if (coverages.tgl) {
      result[0] = {
        carrier: coverages.tgl.carrier,
        carrier_naic: coverages.tgl.carrier_naic || ""
      };
    }

    // Insurer B: Auto Liability (al)
    if (coverages.al) {
      result[1] = {
        carrier: coverages.al.carrier,
        carrier_naic: coverages.al.carrier_naic || ""
      };
    }

    // Insurer C: Motor Truck Cargo (mtc)
    if (coverages.mtc) {
      result[2] = {
        carrier: coverages.mtc.carrier,
        carrier_naic: coverages.mtc.carrier_naic || ""
      };
    }

    // Insurer D: Auto Physical Damage (apd)
    if (coverages.apd) {
      result[3] = {
        carrier: coverages.apd.carrier,
        carrier_naic: coverages.apd.carrier_naic || ""
      };
    }

    return result;
  }

  const extractedInfo = extractCarrierInfo(data.coverages);
  const effectiveDates = data.coverages ? Object.values(data.coverages).reduce((dates, coverage) => {
    if (coverage && coverage.effective_date) {
      dates.push(coverage.effective_date);
    }
    return dates;
  }, []) : [];

  return (
    <Document title="Certificate of Insurance">
      <Page size="A4">
        <View
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <Header />
          <PartOne
            agency={agency}
            contact={contact}
            producer={producer}
            insured={data.insuredInformation}
            carrierInfo={extractedInfo}
          />
          <PartTwo coverages={data.coverages || {}} />
          <Desription
            vehicles={data.vehicles || []}
            additionalRemarks={data.additional_remarks}
            effectiveDates={effectiveDates}
          />
          <Holder customerHolder={customerHolder} signature={signature} />
        </View>
      </Page>
    </Document>
  );
}

export default Certificate;
